exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--7-1!../../styles/colors.css"), "");

// Module
exports.push([module.id, ".src-components-UnconnectedVisitModal-___styles__body___10uaV {\n  text-align: center;\n}\n\n.src-components-UnconnectedVisitModal-___styles__error___2eKM4 {\n  color: #ea5e3e;\n}\n", ""]);

// Exports
exports.locals = {
	"colors": "\"../../styles/colors.css\"",
	"primary4": "" + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--7-1!../../styles/colors.css").locals["primary4"] + "",
	"body": "src-components-UnconnectedVisitModal-___styles__body___10uaV",
	"error": "src-components-UnconnectedVisitModal-___styles__error___2eKM4"
};